import React from "react";
import { motion } from "framer-motion";
import freshstartImage from "./Images/freshstart2.jpg";
import image2 from "./Images/Transform your English - Fresh Start 04.svg";
import image1 from "../../../Images/coursecard_images/freshstart_1.jpg";
import image3 from "../../../Images/coursecard_images/freshstart_2.jpg";

import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  CardMedia,
  Button,
  List,
  ListItem,
  ListItemText,
  Grid,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import Nav from "../../../Nav";

const FreshStart = () => {
  return (
    <>
      <motion.div
        className="p-5 font-sans bg-gray-100 h-4/5 mt-20"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Page Title */}
        <h1 className="text-4xl font-extrabold text-gray-600 text-center mb-8">
          Fresh Start - Rade Bjelan
        </h1>

        
      </motion.div>
      <Nav />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Box
          sx={{
            backgroundColor: "#f8fafc",
            py: 5,
            fontFamily: "Arial, sans-serif",
          }}
        >
          <Box
            sx={{
              backgroundImage: `url(${freshstartImage})`,
              backgroundSize: "cover",
              py: 10,
              textAlign: "center",
              color: "#fff",
            }}
          >
            <Container maxWidth="lg">
              <Typography
                variant="h1"
                align="center"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                  color: "#fff",
                }}
              >
                Fresh Start
              </Typography>
            </Container>
          </Box>

          <Container
            maxWidth="lg"
            sx={{ backgroundColor: "#ffffff", p: 5, borderRadius: 2, mt: -8 }}
          >
            <Grid container spacing={5} alignItems="flex-start">
              <Grid item xs={12} lg={6}>
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    fontWeight: "bold",
                    color: "#172b4d",
                  }}
                >
                  Take Control of Your English
                </Typography>
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    fontWeight: "bold",
                    color: "#172b4d",
                  }}
                >
                  <i>
                    <u>
                      <b>Pronounce any English word correctly</b>
                    </u>
                  </i>{" "}
                  and handle your pronunciation effortlessly with our
                  <i>
                    <b>
                      <u> Fresh Start workshop.</u>
                    </b>
                  </i>
                </Typography>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: 1.6,
                    color: "#6b778c",
                  }}
                >
                  <i>
                    <b>
                      Do you feel discouraged or even doubtful about your
                      English?
                    </b>
                  </i>{" "}
                  Have you enrolled in various English courses in the past but
                  haven’t noticed any major progress?
                </Typography>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: 1.6,
                    color: "#6b778c",
                  }}
                >
                  Most disappointed people find it hard to keep trying. Well,
                  that much is clear!
                  <u>
                    <i>
                      The task of mastering a foreign language can be
                      overwhelming.
                    </i>
                  </u>
                  What matters the most is{" "}
                  <u>
                    <i>the approach and attitude,</i>
                  </u>{" "}
                  not only your own but{" "}
                  <i>
                    <u>the pedagogic and human approach to you</u>
                  </i>{" "}
                  and the realistic
                  <i>
                    <u> goals you wish to achieve.</u>
                  </i>
                </Typography>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: 1.6,
                    color: "#6b778c",
                  }}
                >
                  Many of you might feel frustrated and unable to change your
                  current level in English. Or you are unsure about the steps
                  you should take to finally start speaking and to{" "}
                  <u>
                    <i>get rid of your fear and insecurity.</i>
                  </u>
                </Typography>
              </Grid>
              <Grid item xs={10} lg={6}>
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <CardMedia
                    component="img"
                    image={freshstartImage}
                    alt="Fresh Start"
                    sx={{
                      borderRadius: 2,
                    }}
                  />
                </motion.div>
              </Grid>
            </Grid>
            <Typography
              variant="body1"
              paragraph
              sx={{
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#6b778c",
              }}
            >
              <i>
                <u>
                  Let’s check some of the issues you might be struggling with:
                </u>
              </i>
            </Typography>
            <List>
              {[
                "<strong><u><i>I can’t understand</i></u></strong> people speaking in English no matter how carefully I keep listening.",
                "<strong><u><i>Many similar-sounding words mean different things, but I can’t see the difference.</i></u></strong>",
                "<strong><u><i>Native speakers speak too fast,</i></u></strong> and I can’t understand what they’re saying.",
                "<strong><u><i>I can’t respond appropriately because I can’t understand many expressions and phrases.</i></u></strong>",
                "<strong><u><i>I don’t feel confident when I need to speak.</i></u></strong>",
                "I didn’t know that the words, cook, dance, drink and fight are both, nouns and verbs - and I can’t use both options, I just know 1 single meaning.",
                "<strong><u><i>Many English words have completely different meanings, based on the context and I am not sure how to express 3-4 different situations with the same word.</i></u></strong>",
                "<strong><u><i>I can’t focus on my training or seminars</i></u></strong> because I often can’t understand the speaker.",
                "My new boss and many coworkers are native speakers and I just got hired recently.",
                "I<strong><u><i> didn’t need to use English for a long time</i></u></strong> but now I need to make phone calls in English and speak to foreigners daily and it feels frightening.",
                "<strong><u><i>People don’t seem to understand me much.</i></u></strong>",
              ].map((challenge, index) => (
                <ListItem key={index}>
                  <CheckCircle color="primary" sx={{ mr: 2 }} />
                  <ListItemText
                    primary={
                      <Typography
                        dangerouslySetInnerHTML={{ __html: challenge }}
                      />
                    }
                    primaryTypographyProps={{
                      sx: { fontFamily: "Arial, sans-serif" },
                    }}
                  />
                </ListItem>
              ))}
            </List>
            <Grid item xs={12} lg={10}>
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CardMedia
                  component="img"
                  image={image2}
                  alt="Fresh Start"
                  sx={{
                    borderRadius: 2,
                    width: "100%",
                    paddingBottom: "19px",
                  }}
                />
              </motion.div>
            </Grid>

            <CardContent>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                How can you overcome those difficulties and fluently express
                your thoughts and ideas in English? There is a successful way
                because you learn how to produce every sound in English
                correctly, one-by-one. The technique deals with the sounds until
                they are all mastered and you can speak without mistakes.
                Besides, you will hear others correctly and you will avoid
                common misunderstandings.
              </Typography>
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                  color: "#172b4d",
                }}
              >
                How does it work?
              </Typography>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                  color: "#172b4d",
                }}
              >
                <i>
                  <u>Isolated Sound Practice</u>
                </i>
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                It may sound like you are starting{" "}
                <i>
                  <u>with the basics.</u>
                </i>{" "}
                It’s because you are! You skipped those pronunciations in the
                past and{" "}
                <i>
                  <u>
                    you need them <b>NOW</b>
                  </u>
                </i>{" "}
                to start speaking correctly.{" "}
                <u>
                  <i>
                    <b>YOU CAN and will master the individual sounds.</b>
                  </i>
                </u>{" "}
                It will require some time and effort, and I am here to
                <u>
                  <i> make it as manageable and easy for you as possible.</i>
                </u>
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                We will{" "}
                <i>
                  <u>
                    show you in practice how to position your chin, facial
                    muscles, mouth, and tongue to produce the correct sounds in
                    English.
                  </u>
                </i>{" "}
                This basic yet most effective way works on{" "}
                <i>
                  <u>the mechanics behind the correct pronunciation.</u>
                </i>
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <i>
                  <b>You cannot learn the pronunciation by heart,</b>
                </i>{" "}
                but{" "}
                <i>
                  <b>
                    <u> you can learn how to produce the sounds correctly.</u>
                  </b>
                </i>{" "}
                Once you master the phonemes or sounds in English, you will
                start applying the same
                <i>
                  <b>
                    <u>technique permanently with every new word you learn.</u>
                  </b>
                </i>
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <i>
                  <b>
                    <u>
                      As a result, you will be able to read, speak, and
                      pronounce every single word in the English language.
                    </u>
                  </b>
                </i>{" "}
                You will{" "}
                <i>
                  <u>
                    <b>correct your existing wrong pronunciation</b>
                  </u>
                </i>{" "}
                and start speaking well in your daily life. Our feedback in
                real-time will assist you in directly{" "}
                <i>
                  <u>
                    <b>correcting your old mistakes</b>
                  </u>
                </i>{" "}
                and{" "}
                <b>
                  <i>
                    <u>developing your new speaking patterns.</u>
                  </i>
                </b>
              </Typography>
              <Grid item xs={12} lg={11} container spacing={2}>
                <Grid item xs={6} paddingBottom={"20px"}>
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                  >
                    <CardMedia
                      component="img"
                      image={image1}
                      alt="Fresh Start"
                      sx={{ borderRadius: 2 }}
                    />
                  </motion.div>
                </Grid>
                <Grid item xs={6}>
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                  >
                    <CardMedia
                      component="img"
                      image={image3}
                      alt="Fresh Start"
                      sx={{ borderRadius: 2 }}
                    />
                  </motion.div>
                </Grid>
              </Grid>

              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                  color: "#172b4d",
                }}
              >
                <i>
                  <u>Contextual Practice</u>
                </i>
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                Integrate these sounds into words and sentences. Practice with
                minimal pairs and word lists to fine-tune your ability to
                distinguish similar sounds.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <u>
                  You will speak more fluently and naturally, reducing common
                  pronunciation errors.
                </u>
              </Typography>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                  color: "#172b4d",
                }}
              >
                <b>
                  <u>Interactive Speaking</u>
                </b>
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                Join the conversation during our group sessions with our team
                and speak in real-time as you witness your improvement in
                pronunciation. Practice makes perfect, and with time, you will
                start noticing the difference.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                Real-life practice with feedback helps you apply your skills in
                practical scenarios, boosting your confidence and competence.
              </Typography>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                  color: "#172b4d",
                }}
              >
                <b>
                  <u>Listening and Imitation</u>
                </b>
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                Improve your listening skills by mimicking native speakers. Use
                resources like podcasts, movies, and songs to hear and practice
                authentic pronunciation.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                The{" "}
                <b>
                  <i>
                    <u>full immersion technique </u>
                  </i>
                </b>
                works because it forces you to communicate in English until you{" "}
                <i>
                  <u>
                    <b>break your language barrier.</b>
                  </u>
                </i>{" "}
                Stop translating in your mind from English into your native
                language, as it will slow you down. Instead, focus on thinking
                in English.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <u>
                  <b>
                    <i>
                      Apply this rule and you will start noticing the
                      difference. It might not be an overnight miracle, but you
                      will start noticing your improvement in spoken English.
                    </i>
                  </b>
                </u>
              </Typography>
            </CardContent>
            <div className="flex flex-col md:flex-row gap-6 items-center justify-center">
          {/* Card 1: Course Details */}
          <div className="w-full md:w-1/2 bg-green-100 shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-bold text-gray-800 text-center mb-4">
              Online Group Workshop
            </h2>
            <p className="text-gray-700 mb-2">
              <strong>Type of course:</strong> Online group workshop
            </p>
            <p className="text-gray-700 mb-2">
              <strong>Number of lessons:</strong> 12 online lessons (2 hours per
              class, once a week).
            </p>
            <p className="text-gray-700 mb-2">
              <strong>Price:</strong> $480
            </p>
            <p className="italic text-gray-600 mt-4 text-center">
              Contact us by mail to put your name on the waiting list.
            </p>
          </div>

          {/* Card 2: Bundle Pricing */}
          <div className="w-full md:w-1/2 bg-blue-100 shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-bold text-gray-800 text-center mb-4">
              Bundle Price Option
            </h2>
            <p className="text-gray-700 mb-4 text-center">
              <strong>Bundle Price:</strong> $740 for a bundle package, which
              includes the following courses:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>
                <strong>English At Work</strong> - 1 year access, a
                self-studying course (group live classes are NOT included).{" "}
                <em>(You Save $240)</em>
              </li>
              <li>
                <strong>Dictation Course</strong> - 1 year access, a
                self-studying course. <em>(You Save $280)</em>
              </li>
              <li>
                <strong>Intonation Course</strong> - 1 year access, a
                self-studying course. <em>(You Save $260)</em>
              </li>
              <li>
                <strong>Vocabulary Booster</strong> - 1 year access, a
                self-studying course. <em>(You Save $290)</em>
              </li>
            </ul>
            <p className="mt-4 font-bold text-center">
              Save: $1,070 by purchasing this bundle package.
            </p>

            <div className="mt-6 text-sm text-gray-600">
              <p className="font-semibold">Important:</p>
              <ul className="list-disc list-inside space-y-1 mt-2">
                <li>Only adults are eligible to take our lessons.</li>
                <li>Each price listed is per student.</li>
                <li>
                  If you request a refund for the FRESH START course within 14
                  days of your payment, your access to the Bundle courses will
                  be revoked.
                </li>
              </ul>
            </div>
          </div>
        </div>
            <Box textAlign="center" mt={4} mb={4}>
              <a
                href="http://radebjelan.com/freshstart"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  sx={{ borderRadius: 5, px: 5, py: 2 }}
                >
                  Join Now
                </Button>
              </a>
            </Box>
          </Container>
        </Box>
      </motion.div>
    </>
  );
};

export default FreshStart;
